import { useState, useEffect } from 'react'
import { getResumenSemanal, enviarResumenSemanal } from '../../api/client'
import Modal from '../Modal'
import { detalleError } from './detalle'

// The Monday email to the whole company (backend resumen_semanal.py): who is
// away this week, holidays and company events, birthdays. Sent on its own
// every Monday from 8:00 to the group address; here an admin previews it,
// sends a test to themselves, or sends it now.
export default function CorreoSemanal({ t }) {
  const [info, setInfo] = useState(null)
  const [ver, setVer] = useState(false)
  const [msg, setMsg] = useState('')
  const [busy, setBusy] = useState(false)

  const cargar = () => getResumenSemanal().then(setInfo).catch(() => setInfo(null))
  useEffect(() => { cargar() }, [])

  const enviar = async (prueba) => {
    if (!prueba && !window.confirm(t('correoSemanal.confirmar', { a: info?.destinatario }))) return
    setBusy(true); setMsg('')
    try {
      const r = await enviarResumenSemanal({ lunes: info?.lunes, prueba })
      setMsg(t('correoSemanal.enviado', { a: r.a }))
      cargar()
    } catch (e) {
      setMsg(detalleError(e, t('correoSemanal.failed')))
    }
    setBusy(false)
  }

  const boton = 'border border-gray-200 bg-white text-gray-700 px-3 py-1.5 rounded-lg text-sm font-medium hover:bg-gray-50 disabled:opacity-40'
  return (
    <div className="bg-white border border-gray-200 rounded-xl px-5 py-4 mb-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="min-w-0">
          <h2 className="text-sm font-semibold text-gray-900">{t('correoSemanal.titulo')}</h2>
          <p className="text-xs text-gray-500 mt-0.5">
            {info?.destinatario
              ? t('correoSemanal.estado', { a: info.destinatario })
              : t('correoSemanal.sinDestino')}
            {info?.ultimo_envio && ` · ${t('correoSemanal.ultimo', { cuando: new Date(info.ultimo_envio + 'Z').toLocaleString() })}`}
          </p>
        </div>
        <div className="flex gap-2">
          <button className={boton} disabled={!info} onClick={() => setVer(true)}>{t('correoSemanal.vista')}</button>
          <button className={boton} disabled={!info || busy} onClick={() => enviar(true)}>{t('correoSemanal.prueba')}</button>
          <button className={boton} disabled={!info?.destinatario || busy} onClick={() => enviar(false)}>{t('correoSemanal.ahora')}</button>
        </div>
      </div>
      {msg && <p className="text-xs text-gray-600 mt-2">{msg}</p>}
      {ver && info && (
        <Modal title={info.asunto} onClose={() => setVer(false)} wide>
          <iframe title={info.asunto} srcDoc={info.html} className="w-full h-[60vh] border border-gray-100 rounded-lg" />
        </Modal>
      )}
    </div>
  )
}
